import React from "react";

import { Wrapper, Content, Avatar, Text } from "./Hero.styles";

import AVATAR from "../../images/avatar.jpg";

const Hero = () => (
  <Wrapper>
    <Content>
      <Avatar src={AVATAR} alt="It's just a photo of me lol." />
      <Text>
        <h1>
          Hi, I am Mohamed <b>- a Software</b>
        </h1>
        <h1>
          <b>developer </b> and <b>IT engineer.</b>
        </h1>
        <p>
          I help people through their digital transformation by building <br />
          modern looking <b>website, management software</b> and{" "}
          <b>IT support</b>.
        </p>
      </Text>
    </Content>
  </Wrapper>
);

export default Hero;
